const styles = {
    nameTextFieldStyle: {
        width: '270px',
        paddingBottom: '10px'
    },
    addrTextFieldStyle: {
        width: '280px',
        paddingBottom: '10px'
    },
    textFieldStyle: {
        width: '310px',
        paddingBottom: '10px'
    },
    heightTextFieldStyle: {
        width: '90px',
        paddingBottom: '10px'
    },
    appInfoNameTextFieldStyle: {
        width: '180px',
        paddingBottom: '10px'
    }, 
    appInfoAmountTextFieldStyle: {
        width: '130px',
        paddingBottom: '10px',
        marginLeft: '10px',
        fontSize: '9px'
    } 
}

export default styles;


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/common/styles.js